import { render, staticRenderFns } from "./SdsTableSection3Impurity.vue?vue&type=template&id=2f54d2d9"
import script from "./SdsTableSection3Impurity.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsTableSection3Impurity.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports